import urljoin from 'url-join';
import ky from './kyInstance';
import qs from 'qs';

import { BASE_PATH, withAuthorizationHeader } from '..';

export const getMaTrainingsList = async (params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'training', 'ma'), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const maCreateTraining = async (params) => {
  return ky.post(urljoin(BASE_PATH, 'training', 'ma', 'create'), {
    headers: withAuthorizationHeader(),
    body: params instanceof FormData ? params : JSON.stringify(params),
  });
};

export const maUpdateTraining = async (id, params) => {
  return ky.post(urljoin(BASE_PATH, 'training', 'ma', 'edit', String(id)), {
    headers: withAuthorizationHeader(),
    body: params instanceof FormData ? params : JSON.stringify(params),
  });
};

export const maRemoveTraining = async (id) => {
  return ky.delete(urljoin(BASE_PATH, 'training', 'ma', 'delete', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const getTrainingCourseOptions = async (params) => {
  const query = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');

  return ky.get(urljoin(BASE_PATH, 'training', 'courses', 'options', `?${query}`), {
    headers: withAuthorizationHeader(),
  });
};

export const getTrainingCourseDetail = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'training', 'courses', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const importTrainingsData = async ({ payload }) => {
  return ky.post(urljoin(BASE_PATH, 'training', 'import'), {
    headers: withAuthorizationHeader(),
    body: payload,
  });
};

export const getMaCpdDiplomasList = async (params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'training', 'ma', 'diplomas'), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const getMaCompetenciesList = async (params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'training', 'ma', 'competencies'), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const getMaCpdCoursesList = async (params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'training', 'ma', 'courses'), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

const handleExcelDownload = async (response, type) => {
  if (response.ok) {
    try {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.download = `${type}.xlsx`;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  }
  return response;
};

export const downloadTrainingsImportTemplate = async () => {
  const response = await ky.get(urljoin(BASE_PATH, 'training', 'import-template'), {
    headers: {
      ...withAuthorizationHeader(),
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
  return handleExcelDownload(response, 'import-trainings');
};

const handleZipDownload = async (response, name) => {
  if (response.ok) {
    try {
      const blob = await response.blob();
      const today = new Date();
      const formattedDate = `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
      const fileName = `${name}-${formattedDate}.zip`;
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/zip' }));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  }
  return response;
};

export const exportCpdDiplomasToZip = async (params = {}) => {
  const response = await ky.post(urljoin(BASE_PATH, 'training', 'ma', 'diplomas', 'pdf-zip'), {
    headers: {
      ...withAuthorizationHeader(),
      Accept: 'application/zip',
    },
    searchParams: qs.stringify(params),
  });
  return handleZipDownload(response, 'cpd-diplomas');
};
